module.exports = __webpack_public_path__ + "static/img/funny_18.18e61f3b.jpg";